import React from "react";
import PropTypes from "prop-types";
import get from "lodash.get";
import {translate} from "admin-on-rest";
import {BMTheme} from "../../BMTheme";

const styles = {
  list: {
    display: "flex",
    listStyleType: "none",
    paddingLeft: 0
  },
  image: {
    margin: "0.5rem",
    maxHeight: "10rem"
  }
};

const viewStyle = {
  textFieldContainer: {
    marginTop: 10
  },

  labelFieldStyle: {
    textTransform: "sentencecase",
    lineHeight: " 22px",
    fontSize: "12px",
    color: BMTheme.label.labelDefaultColor
  }
};

const ImageLabelBase = ({translate, validDimensions}) => {
  return (
    <div style={viewStyle.textFieldContainer}>
      <span style={viewStyle.labelFieldStyle}>
        {translate("resources.promos.fields.image", {
          dimensions: validDimensions
        })}
      </span>
    </div>
  );
};
const ImageLabel = translate(ImageLabelBase);

const SmallImageLabelBase = ({translate, validDimensions}) => {
  return (
    <div style={viewStyle.textFieldContainer}>
      <span style={viewStyle.labelFieldStyle}>
        {translate("resources.promos.fields.smallImage", {
          dimensions: validDimensions
        })}
      </span>
    </div>
  );
};
const SmallImageLabel = translate(SmallImageLabelBase);

export const ImageField = ({
  elStyle = {},
  record,
  source,
  src,
  title,
  validDimensions
}) => {
  const sourceValue = get(record, source);

  if (!sourceValue) {
    return <div />;
  }

  if (Array.isArray(sourceValue)) {
    const style = {
      ...styles.list,
      ...elStyle
    };

    return (
      <div>
        <ul style={style}>
          {sourceValue.map((file, index) => {
            const titleValue = get(file, title) || title;
            const srcValue = get(file, src) || title;

            return (
              <li key={index}>
                <img
                  alt={titleValue}
                  title={titleValue}
                  src={srcValue}
                  style={styles.image}
                />
              </li>
            );
          })}
        </ul>
      </div>
    );
  }

  const titleValue = get(sourceValue, title) || title;

  return (
    <div style={elStyle}>
      {source === "images.large" ? (
        <ImageLabel validDimensions={validDimensions} />
      ) : (
        <SmallImageLabel validDimensions={validDimensions} />
      )}
      <img
        title={titleValue}
        alt={titleValue}
        src={sourceValue.src}
        style={styles.image}
      />
    </div>
  );
};

ImageField.propTypes = {
  elStyle: PropTypes.object,
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
  title: PropTypes.string
};

export default ImageField;



// WEBPACK FOOTER //
// ./src/components/CRM/ImageField.js